import PropTypes from 'prop-types';

const LibraryResourceType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
});

export default LibraryResourceType;
